import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormContext from "../context/formContext";
import BackLogout from "../component/backLogout";
import { useToast } from "@chakra-ui/react";
import Loader from "../component/loader";

function FormStart() {
  const toast = useToast();
  const context = useContext(FormContext);
  const { loginObj, setLoginObj, setSubjects, stateArr, stateList } = context;
  const navigate = useNavigate();

  const [fsloader, setFSloader] = useState(false);
  const [showCourse, setShowCourse] = useState(false);
  const [inDate, setInDate] = useState(false);

  useEffect(() => {
    window.onbeforeunload = () => {
      return "";
    };

    stateList();
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=ks1r6e3hp01h9psp1ufu608e45l56ri4");
    myHeaders.append("auth_token", localStorage.getItem("token"));
    var raw = JSON.stringify({
      // Branch_id: "1790",
      Branch_id: "2245",
      student_id: localStorage.getItem("studentId"),
      db_name: "erp_eshiksa",
      email: localStorage.getItem("email"),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/getStudentData.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        var resultObj = JSON.parse(result);
        console.log(resultObj);

        if (resultObj.success === 1) {
          setLoginObj(resultObj.form_data);
        }
      })
      .catch((error) => console.log("error", error));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const currentTime = new Date();
    const august3 = new Date(currentTime.getFullYear(), 7, 3, 23, 59, 0, 0);
    // Set the start date and time for August 5, 2023 (00:00 AM)
    const august5 = new Date(2023, 7, 5, 0, 0, 0, 0);

    // Set the end date and time for August 14, 2023 (11:59 PM)
    const august14 = new Date(2023, 7, 14, 23, 59, 0, 0);

    // Compare the current date and time with August 3, 11:59 PM
    if (currentTime < august3) {
      setInDate(true);
      setShowCourse(false);
    } else if (currentTime >= august5 && currentTime <= august14) {
      setInDate(false);
      setShowCourse(true);
    } else {
      setShowCourse(false);
      setInDate(false);
    }
  }, []);

  const handleSaveFromStart = () => {
    // loginObj["Branch_id"] = "1790";
    loginObj["Branch_id"] = "2245";
    loginObj["db_name"] = "erp_eshiksa";
    loginObj["student_id"] = localStorage.getItem("studentId");
    loginObj["formName"] = "UG_and_Diploma";
    loginObj["email"] = localStorage.getItem("email");

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=gliuijh4lm0h2rlafbvtgo6r8vj6f9if");
    myHeaders.append("auth_token", localStorage.getItem("token"));

    var raw = JSON.stringify(loginObj);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("https://erpapi.eshiksa.net/Gadvasu/SaveData.php", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        var responseObjFS = JSON.parse(result);
        console.log(responseObjFS);
        if (responseObjFS.success === 1) {
          setFSloader(false);
          toast({
            title: "Alert",
            description: responseObjFS.msg,
            status: "success",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
          navigate("/FormPage1");
        } else {
          setFSloader(false);
          toast({
            title: "Alert",
            description:
              "You have already paid for a course or Something went wrong....!!!",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      })
      .catch((error) => console.log("error", error));
  };

  const handleFormStart = (e) => {
    e.preventDefault();
    console.log(loginObj);
    setFSloader(true);

    if (loginObj.resident === "Yes") {
      if (loginObj.student_Category !== " " && loginObj.CourseName !== " ") {
        handleSaveFromStart();
      }
    } else if (loginObj.resident === "No") {
      if (loginObj.stateName !== " " && loginObj.CourseName !== " ") {
        handleSaveFromStart();
      }
    } else {
      alert("Please fill all the fields.");
    }
  };

  return (
    <React.Fragment>
      <div className="container-fluid" style={{ width: "95%" }}>
        <div>
          <button
            className="btn btn-sm my-2 "
            style={{ border: "1px solid #a6191f", color: "#a6191f" }}
          >
            {" "}
            <i className="fa-solid fa-user mx-2"> </i>
            {loginObj.name}
          </button>

          <BackLogout />
        </div>
        <div className="container" style={{ height: "100vh" }}>
          <div className="w-100 form_input_header rounded-3 my-3">
            <h3 className="text-light text-center p-3">
              {/* Application Form for U.G. and Diploma 2-years. */}
              Application Form to apply Admission
            </h3>
          </div>

          <form onSubmit={(e) => handleFormStart(e)}>
            <div className="row border border-3 rounded-3 my-3">
              <div className="p-0">
                <div className="w-100 p-1 pt-2 px-3 form_input_header">
                  <h6 className="text-light"> Details</h6>
                </div>
              </div>
              <div className="row p-3">
                <div className="col-sm-12 col-lg-4 d-flex flex-column">
                  <div>
                    {" "}
                    <h6>
                      Are you a resident of Punjab or Chandigarh(U.T.)
                    </h6>{" "}
                  </div>
                  <div className="d-flex flex-row">
                    <div
                      className="mx-2"
                      name="resident"
                      value={loginObj.resident}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <input
                        className="form-check-input ms-2"
                        type="radio"
                        value="Yes"
                        name="resident"
                        required
                        checked={loginObj.resident === "Yes" ? true : false}
                      />{" "}
                      Yes
                      <input
                        className="form-check-input ms-2"
                        type="radio"
                        value="No"
                        name="resident"
                        required
                        checked={loginObj.resident === "No" ? true : false}
                      />{" "}
                      No
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-lg-4">
                  {/* <label for="formFile" className="form-label"> */}
                  <label htmlFor="formFile" className="form-label">
                    Programme Applied For
                  </label>
                  <select
                    name="CourseName"
                    className="form-select"
                    value={loginObj.CourseName}
                    onChange={(e) => {
                      setLoginObj({
                        ...loginObj,
                        [e.target.name]: e.target.value,
                      });
                      setSubjects(e.target.value);
                    }}
                    required
                  >
                    <option value="">Select</option>
                    {/* diplomacase */}

                    {/* {showCourse && <option value="UG">UG</option>}
                    {inDate && (
                      <option value="Diploma-2 years">Diploma-2 years</option>
                    )} */}

                    {/* ugcase */}
                    {/* {inDate && <option value="UG">UG</option>}
                    {showCourse && <option value="Diploma-2 years">Diploma-2 years</option>}  */}

                    {/* bothcase */}
                    {/* <option value="UG">UG</option>*/}
                     <option value="Diploma-2 years">Diploma-2 years</option> 
                  </select>
                </div>

                {loginObj.resident === "Yes" &&
                  loginObj.CourseName === "UG" && (
                    <div className="col-sm-12 col-lg-4">
                      <label htmlFor="formFile" className="form-label">
                        Caste Category
                      </label>
                      <select
                        name="student_Category"
                        value={loginObj.student_Category}
                        className="form-select"
                        onChange={(e) =>
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          })
                        }
                        required
                      >
                        <option value="" selected>
                          Select
                        </option>
                        <option value="General">General</option>
                        <option value="Gen/EWS">Gen - EWS</option>
                        <option value="SC/ST">SC/ST</option>
                        <option value="BC">BC</option>
                      </select>
                    </div>
                  )}

                {loginObj.resident === "Yes" &&
                  loginObj.CourseName === "Diploma-2 years" && (
                    <div className="col-sm-12 col-lg-4">
                      <label htmlFor="formFile" className="form-label">
                        Caste Category
                      </label>
                      <select
                        name="student_Category"
                        value={loginObj.student_Category}
                        className="form-select"
                        onChange={(e) =>
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          })
                        }
                        required
                      >
                        <option value="" selected>
                          Select
                        </option>
                        <option value="General">General</option>
                        <option value="Gen/EWS">Gen-EWS</option>
                        <option value="SC/ST">SC/ST</option>
                        <option value="BC">BC</option>
                      </select>
                    </div>
                  )}

                {loginObj.resident === "No" && (
                  <div className="col-sm-12 col-lg-4">
                    {/* <label for="formFile" className="form-label"> */}
                    <label htmlFor="formFile" className="form-label">
                      Select State
                    </label>
                    <select
                      name="stateName"
                      className="form-select"
                      value={loginObj.stateName}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="" selected disabled>
                        Select
                      </option>
                      {stateArr.map((item, i) => {
                        if (
                          item.state_name === "Punjab" ||
                          item.state_name === "Chandigarh"
                        ) {
                          return null;
                        }
                        return (
                          <option key={i} value={item.state_name}>
                            {item.state_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}
              </div>

              <div className="row p-3">
                <div className="col-sm-12 col-lg-4">
                  {/* <label for="formFile" className="form-label"> */}
                  <label htmlFor="formFile" className="form-label">
                    Studied at +2 Level
                  </label>
                  <select
                    name="subjectsName"
                    className="form-select"
                    value={loginObj.subjectsName}
                    onChange={(e) =>
                      setLoginObj({
                        ...loginObj,
                        [e.target.name]: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="" selected disabled>
                      Select
                    </option>
                    <option value="Physics, Chemistry, English, Biology">
                      Physics, Chemistry, English, Biology
                    </option>
                  </select>
                </div>

                <div className="col-sm-12 col-lg-4">
                  {/* <label for="formFile" className="form-label"> */}
                  <label htmlFor="formFile" className="form-label">
                    Programme Name
                  </label>
                  <select
                    name="TestSelected"
                    className="form-select"
                    value={loginObj.TestSelected}
                    onChange={(e) =>
                      setLoginObj({
                        ...loginObj,
                        [e.target.name]: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="">Select</option>
                    {loginObj.CourseName === "UG" && (
                      <option value="B.V.Sc. & A.H.">B.V.Sc. & A.H.</option>
                    )}
                    {loginObj.CourseName === "Diploma-2 years" && (
                      <option value="Diploma in Veterinary Science & Animal Health Technology">
                        Diploma in Veterinary Science & Animal Health
                        Technology.
                      </option>
                    )}
                  </select>
                </div>
              </div>
            </div>
            {loginObj.resident === "No" ? 
             
             <div className="row justify-content-around">
              <p style={{ color: "red" }}>
              Applicant should be only resident of Punjab/ U.T. of Chandigarh.
              </p>
            </div>
             : ''}
            <div className="row justify-content-around my-5">
              <button
                type="submit"
                className="btn btn-primary w-25"
                disabled={fsloader || loginObj.resident === "No" ? true : false}
              >
                Submit
                {fsloader && <Loader />}
              </button>
            </div>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
}

export default FormStart;
